export const REQUESTED_URL_KEY = 'requestedUrl';
export const DEFAULT_SORT_COL: string = null;

// Constants for trade and order-details widgets
export const MAX_PRICE_VALUE: number = 999999999;
export const MAX_QUANTITY_VALUE: number = 999999999;
export const DEFAULT_MIN_NOTIONAL: number = 0;

export const TWO_FACTOR_AUTH_CODE_LENGTH = 6;

// TODO: [HED-421, TT-140] Replace button is temporarily hidden
export const IS_ORDER_REPLACE_DISABLED: boolean = true;
